import React, { useState } from 'react'
import { Progress } from 'antd'
import { Form, Input } from 'antd'
import { useTranslation } from 'react-i18next'

const SUCCESS = 'Password.ok'

const FormItemPasswordProgress = ({ placeholder }) => {
  const [password, setPassword] = useState({
    password: '',
  })
  const [percent, setPercent] = useState(0)
  const { t } = useTranslation()

  const validatePassword = (password) => {
    let strength = 0
    let error = null
    if (password.length > 8) {
      strength += 25
    } else {
      error = 'Password.error.MinLength'
    }
    if (password.match(/^(?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_₹]).*$/)) {
      strength += 25
    } else {
      error = 'Password.error.SpecialCharacter'
    }
    if (password.match(/[0-9]+/)) {
      strength += 25
    } else {
      error = 'Password.error.OneNumber'
    }
    if (password.match(/[a-zA-Z]+/)) {
      strength += 25
    } else {
      error = 'Password.error.OneLetter'
    }

    setPercent(strength)
    return {
      password: password,
      errorMsg: error,
      validateStatus: strength === 100 ? 'success' : 'error',
    }
  }
  const onPasswordChange = (event) => {
    const psw = event.target.value
    setPassword({ ...validatePassword(psw) })
  }

  return (
    <>
      <Form.Item
        label={t('Login.NewPassword')}
        name="password"
        validateStatus={password.validateStatus}
        rules={[
          {
            required: true,
            message: t('Login.error.PleaseEnterPassword'),
          },
          {
            validator: (_, value) =>
              password.validateStatus === 'success'
                ? Promise.resolve()
                : Promise.reject(),
          },
        ]}
      >
        <Input.Password
          value={password.value}
          placeholder={placeholder}
          autoComplete="on"
          onChange={onPasswordChange}
        />
      </Form.Item>
      {percent > 0 && (
        <Form.Item style={{ marginTop: '-10px' }}>
          <>
            <Progress
              percent={percent}
              className={'progress-' + percent}
              showInfo={false}
            />
            <span
              dangerouslySetInnerHTML={{
                __html: t(password.errorMsg || SUCCESS),
              }}
            />
          </>
        </Form.Item>
      )}
    </>
  )
}

export default FormItemPasswordProgress
